import TitleUnderlined from "../components/TitleUnderlined"
import "../styles/map-page.css"
import {BsArrowRight} from 'react-icons/bs';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { divIcon } from "leaflet"
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from "react";
import { getMapPointers } from "../services/API/MapPointerAPI";
import { useNavigate } from "react-router-dom";

const MapPage = () => {
  const [markers, setMarkers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const setMarkersState = async () => {
      const mapPointers = await getMapPointers();
      const mapPointersWithCoords = mapPointers.map(mapPointer => {
        return {
          ...mapPointer,
          coords: [
            mapPointer.latitude,
            mapPointer.longitude,
          ]
        }
      });
      setMarkers(mapPointersWithCoords);
    }
    setMarkersState();
  }, [])

  return (
    <div className="map-page__background-img" id="map-page">
      <div className="map-page__title-container">
        <TitleUnderlined
          title="Kaart"
          bold={true}
          color="white"
          fontSize="2.5rem" 
        />
      </div>
      <div className="map-page__map-container">
        <div className="map-page__map" id="map" >
          <MapContainer center={[37.45, 60.98]} zoom={2} doubleClickZoom={false} zoomControl={false} scrollWheelZoom={false}>
              <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              { markers?.map((marker) => {
                return (
                  <Marker key={marker.id} position={marker.coords} icon={createMarker(marker.color)} >
                    <Popup>
                      <h3 style={{marginBottom: 5}}>{marker.country}</h3>
                      <div className="map-page__map__popup-text-container" onClick={() => navigate(`blogs/all-blogs?search=${marker.country}`)}>    
                        <a>Blogs</a>
                        <BsArrowRight color="#0078A8" size={10}/>
                      </div>
                    </Popup>
                  </Marker>
                )
              })}
          </MapContainer>
        </div>
      </div>
    </div>
  )
}

const createMarker = (color) => {
  const markerHtmlStyles = `
  background-color: ${color};
  width: 0.5rem;
  height: 0.5rem;
  display: block;
  left: -1.5rem;
  top: -1.5rem;
  position: relative;
  border-radius: 3rem;`;

  return divIcon({
      className: "my-custom-pin",
      iconAnchor: [-20, -20],
      labelAnchor: [0, 0],
      popupAnchor: [0, 0],
      html: `<span style="${markerHtmlStyles}" />`
  });
}

export default MapPage
